<template>
	<div>
		<div class="mt-4 container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light mb-4">
			 	<h1 class="h3 mb-0 text-gray-800 mr-4">
					Entregas
			  	</h1>
			  	<button
					class="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
			    	<bsh-nav
						:tabs="tabs"
						name="entregaTab"
						@navChanged="setLink">
					</bsh-nav>
                    <button
                        class="btn btn-primary ml-2"
                        @click="create()">
                        Novo
                    </button>
                </div>
			</nav>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <entrega-table
		            	@show="show"
                        :link="link"
		            	:key="entregaTableKey">
		            </entrega-table>
		        </div>
		    </div>
		</div>
		<entrega-create
			:key="entregaCreateKey"
			@reload="reload">
		</entrega-create>
	</div>
</template>

<script>
	export default {
		data(){
			return {
                tabs: [
                    {
		            	label: 'Todos',
		              	field: '0',
		            },
		            {
		              	label: 'Não finalizados',
		              	field: '1',
		            },
		            {
		              	label: 'Finalizados',
		              	field: '2',
		            },
				],
				entregaTableKey: 1,
				entregaCreateKey: 1,
                link: this.$url+'/api/adm/entregas/datatable',
			}
		},
		methods: {
            setLink(tab){
				this.link = this.$url+'/api/adm/entregas/datatable/'+tab;
				this.entregaTableKey += 1;
			},
			create(){
				$('#create_entrega').modal('show');
			},
			show(dado_id){
				this.$router.push('/adm/entregas/show/'+dado_id)
			},
			reload(){
				this.entregaTableKey += 1;
				this.entregaCreateKey += 1;
			},
		}
	}
</script>
